import { api } from "../APIClient";
import { ACTION_TYPE } from "reducers/actionType";
import { MOST_RELEVANT_SUBJECTS, getSubjects } from "utils/helpers";
import ERROR_TYPE from "utils/errors";
const ENDPOINT_PATH = "/service/stage/1/process";

// a recursive function that retrieves all individual subjects from a list
const pushSubject = (list, el) => {
  if (el.type === "S") {
    list.push(el.subject.subject_num.toString());
  } else {
    el.group.forEach(subrec => pushSubject(list, subrec));
  }
};

export function getRecommendations(userInput) {
  return async dispatch => {
    dispatch({
      type: ACTION_TYPE.recommendationsFetch.begin,
      data: { recommendations: [], loading: true, error: null }
    });

    try {
      const response = await api.post(ENDPOINT_PATH, userInput);
      const { recommendations, recommendations_input_hash } = response.data;
      dispatch({
        type: ACTION_TYPE.recommendationsFetch.success,
        data: {
          recommendations: recommendations,
          loading: false
        }
      });
      dispatch({
        type: ACTION_TYPE.hash,
        data: {
          recommendations_input_hash: recommendations_input_hash
        }
      });

      dispatch(groupRecommendations(recommendations));
    } catch (error) {
      const { response } = error;
      let errorType = null;
      let errors = null;

      if (!response) {
        errorType = ERROR_TYPE.network;
      } else {
        const { status } = response;
        if (400 <= status && status < 500) {
          errorType = ERROR_TYPE.client;
        } else {
          errorType = ERROR_TYPE.server;
        }
        errors = response.data.errors;
      }

      // dispatch({
      //   type: ACTION_TYPE.recommendationsFetch.failure,
      //   data: { error: error, loading: false }
      // });
      dispatch({
        type: ACTION_TYPE.recommendationsFetch.failure,
        data: {
          loading: false,
          error: {
            errorType: errorType,
            errors: errors
          }
        }
      });
    } finally {
      dispatch({
        type: ACTION_TYPE.eligibilityFetch.success,
        data: { eligibility: null, loading: false, error: null }
      });
    }
  };
}

export const groupRecommendations = recommendations => {
  return dispatch => {
    const recommendedSubjects = [];
    const otherSubjects = [];

    recommendations.slice(0, MOST_RELEVANT_SUBJECTS).forEach(sub => {
      pushSubject(recommendedSubjects, sub);
    });

    recommendations
      .slice(MOST_RELEVANT_SUBJECTS, recommendations.length)
      .forEach(sub => {
        pushSubject(otherSubjects, sub);
      });

    const subjects = getSubjects();
    const subjectList = Object.keys(subjects);
    const additionalSubjects = subjectList.filter(
      sub => !(recommendedSubjects.includes(sub) || otherSubjects.includes(sub))
    );

    dispatch({
      type: ACTION_TYPE.recommendedSubjects,
      data: { recommendedSubjects: recommendedSubjects }
    });
    dispatch({
      type: ACTION_TYPE.otherSubjects,
      data: { otherSubjects: otherSubjects }
    });
    dispatch({
      type: ACTION_TYPE.additionalSubjects,
      data: { additionalSubjects: additionalSubjects }
    });
  };
};
